// @ts-nocheck FIXME
import {autorun, computed, makeObservable, observable, reaction} from "mobx";
import app from "../../app.js";
import {accountUuid, accessTokenUuid, syncHandler} from "../../model/index.js";
import {Sync} from "../index.js";
import WsComm from "./ws-comm.js";

export default class WsSync implements Sync {
	private readonly ws: {
		disconnect:          any;
		setHandler:          any;
		setReconnectHandler: any;
		setAuthFailHandler:  any;
		connect:             any;
	} = new WsComm();
	connected = false;
	accountUuid:       accountUuid | null = null;
	accessToken:       accessTokenUuid | null = null;
	private disposers: Function[] = [];

	constructor() {
		console.debug("PN Data WsSync: initializing");
		this.ws = new WsComm();

		makeObservable(this, {
			connected:        observable,
			shouldConnect:    computed,
			shouldDisconnect: computed
		});

		this.disposers.push(autorun(() => {
			if (!this.shouldConnect)
				return;

			console.debug("PN Data WsSync: connecting");
			// Given shouldConnect = true, we know that these variables exist
			this.ws.connect(app.config?.urls.pn_auth_ws, app.accountUuid, app.accessToken, app.config?.userAgent, app.config?.version);
			this.accountUuid = app.accountUuid;
			this.accessToken = app.accessToken;
			this.connected = true;
		}));

		this.disposers.push(reaction(() => this.shouldDisconnect, shouldDisconnect => {
			if (!shouldDisconnect)
				return;

			console.debug("PN Data WsSync: disconnecting");
			if (this.ws)
				this.ws.disconnect();
			this.accountUuid = null;
			this.accessToken = null;
			this.connected = false;
		}));

		this.ws.setAuthFailHandler(app.handleAuthFailure.bind(app));
	}

	setReconnectHandler(fn: () => void) {
		this.ws.setReconnectHandler(fn);
	}

	setHandler(handler: syncHandler, fn: (data: object) => void) {
		this.ws.setHandler(handler, fn);
	}

	handle() {
		throw new Error("PN Data WsSync: calling handle() is not allowed");
	}

	destroy() {
		console.debug("PN Data WsSync: destroying");
		if (this.connected && this.ws)
			this.ws.disconnect();

		this.disposers.forEach(d => d());
		this.disposers = [];
	};

	/**
	 * Returns true whenever ws.connect() should be called. This can happen when:
	 *
	 * - It's the first time connecting, and we have the appropriate config (access token, etc.).
	 * - The access token or account UUID have changed from the last time we connected.
	 */
	get shouldConnect(): boolean {
		if (!app.config?.sync)
			return false;

		if (this.connected)
			return false;

		if (!app.config)
			return false;

		return app.accountUuid !== null && app.accessToken !== null;
	}

	/**
	 * Returns true whenever ws.disconnect() should be called.
	 */
	get shouldDisconnect(): boolean {
		if (!this.connected)
			return false;

		if (!app.config?.sync)
			return true;

		return app.accountUuid !== this.accountUuid || app.accessToken !== this.accessToken;
	}
}
